import React from "react"
import { Table, Divider, Space, Button, Modal, message } from "antd"
import PropTypes from 'prop-types'

import { AdminService } from "@/services"
import CommonLayout from "@/common/Layout"

import AddModal from "./addDeviceModal"
import EditModal from "./editDeviceModal"

class SellingSiteDevicesPage extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            deviceList: [],
            addModalOpen: false,
            editingRecord: null
        }
    }

    componentDidMount() {
        this.reloadTags()
    }

    reloadTags() {
        const params = {}
        AdminService.get_selling_site_filters(params).then((response) => {
            const { status, body } = response.data
            if (status <= 0) {
                console.error("get_selling_site_filters api return status", status)
                return
            }

            this.setState({
                deviceList: body.devices
            })
        })
    }


    openAddModal() {
        this.setState({ addModalOpen: true })
    }

    closeAddModal() {
        this.setState({ addModalOpen: false })
    }

    submitAddModal(formData) {

        const params = {
            device_id: formData.deviceId,
            name: formData.name,
            is_public: formData.isPublic ? 1 : 0
        }

        const messageKey = "notice"

        message.loading({ content: "正在保存...", key: messageKey })

        AdminService.create_selling_site_device(params).then((response) => {

            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            this.reloadTags()

            this.closeAddModal()

            message.success({ content: "添加成功", key: messageKey })

        }).catch((error) => {
            message.error({ content: "添加失败", key: messageKey })
            console.error(error)
        })
    }

    openEditModal(record) {
        this.setState({ editingRecord: record })
    }

    closeEditModal() {
        this.setState({ editingRecord: null })
    }

    submitEditModal(formData) {

        const params = {
            device_id: formData.deviceId,
            name: formData.name,
            is_public: formData.isPublic ? 1 : 0
        }

        const messageKey = "notice"

        message.loading({ content: "正在保存...", key: messageKey })

        AdminService.update_selling_site_device(params).then((response) => {

            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            this.reloadTags()

            this.closeEditModal()

            message.success({ content: "保存成功", key: messageKey })

        }).catch((error) => {
            message.error({ content: "保存失败", key: messageKey })
            console.error(error)
        })

    }

    deleteDevice(record) {

        const params = {
            tag_id: record.id
        }

        const messageKey = "notice"

        message.loading({ content: "正在删除...", key: messageKey })

        return AdminService.delete_selling_site_device(params).then((response) => {

            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            this.reloadTags()

            message.success({ content: "删除成功", key: messageKey })

        }).catch((error) => {
            message.error({ content: "删除失败", key: messageKey })
            console.error(error)
        })
    }

    confirmAndDeleteDevice(record) {
        Modal.confirm({
            title: `确认要删除设备"${record.name}"吗？`,
            content: '删除后将不可恢复，请谨慎操作',
            okText: "确认",
            cancelText: "取消",
            onOk: async () => {
                await this.deleteDevice(record)
            }
        })
    }

    renderAddModal() {

        const { addModalOpen } = this.state
        if (!addModalOpen) return null

        return (
            <AddModal
                onCancel={() => this.closeAddModal()}
                onSubmit={(formData) => this.submitAddModal(formData)}
            />
        )
    }

    renderEditModal() {

        const { editingRecord } = this.state
        if (!editingRecord) return null

        const formData = {
            deviceId: editingRecord.id,
            name: editingRecord.name,
            isPublic: editingRecord.isPublic
        }

        return (
            <EditModal
                formData={formData}
                onCancel={() => this.closeEditModal()}
                onSubmit={(formData) => this.submitEditModal(formData)}
            />
        )
    }


    renderTagsTable() {

        const { deviceList } = this.state

        const columns = [
            {
                title: "设备标识",
                dataIndex: "id",
                key: "id",
                align: "center"
            },
            {
                title: "设备名称",
                dataIndex: 'name',
                key: 'name',
                align: "center"
            },
            {
                title: "是否公开",
                dataIndex: "isPublic",
                key: "isPublic",
                align: "center",
                render: (isPublic, record) => {

                    const color = isPublic ? "green" : "red"
                    const text = isPublic ? "公开" : "不公开"

                    return <span style={{ color: color }}>{text}</span>
                }
            },
            {
                title: '操作',
                key: 'action',
                align: "center",
                render: (text, record) => (
                    <Space>
                        <a onClick={() => this.openEditModal(record)}>编辑</a>
                        <Divider type="vertical" />
                        <a onClick={() => this.confirmAndDeleteDevice(record)}>删除</a>
                    </Space>
                )
            },
        ];

        return (
            <Table
                dataSource={deviceList}
                columns={columns}
                rowKey="id"
                pagination={false}
            />
        )
    }

    renderPageContent() {
        return (
            <React.Fragment>
                <h2>设备列表</h2>

                <div style={{ marginBottom: 20 }}>
                    <Button type="primary" onClick={() => this.openAddModal()}>添加设备</Button>
                </div>
                <div style={{ marginBottom: 20 }}>
                    {this.renderTagsTable()}
                </div>

                {this.renderAddModal()}
                {this.renderEditModal()}
            </React.Fragment>
        )
    }

    render() {
        return (
            <CommonLayout selectedMenuKey="sellingSiteDevices" openMenuKeys={["groupSite"]}>
                {this.renderPageContent()}
            </CommonLayout>
        )
    }

}

export default SellingSiteDevicesPage